import * as React from 'react';

import { PlainMarkdownContext } from './PlainMarkdownProvider';

/**
 * An utility hook to decide how the nodes should be styled
 */
export function usePlainMarkdownStyle() {
    const plainMarkdownCtx = React.useContext(PlainMarkdownContext);

    return React.useMemo(() => {
        return { textStyle: plainMarkdownCtx?.kind === 'secondary' ? 'text-muted' : 'text-base' };
    }, [plainMarkdownCtx]);
}
